module.exports = __webpack_public_path__ + "static/img/10.59298cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/10.png
// module id = tQEv
// module chunks = 0